import camelCase from 'lodash.camelcase';
import { CSSProperties, useMemo } from 'react';
import * as Reactstrap from 'reactstrap';

const UncontrolledTooltip = Reactstrap.UncontrolledTooltip || Reactstrap.default?.UncontrolledTooltip;

type PropsSpan = {
  id?: string,
  title?: string | JSX.Element | object;
  className?: string;
  style?: CSSProperties;
  children?: any;
  onClick?: () => void;
}

export function Span(
  {
    id: defaultId,
    title,
    className,
    style,
    onClick = () => null,
    children
  }: PropsSpan
) {
  const id = useMemo(() => {
    return defaultId || camelCase(`spam-${title}`);
  }, [defaultId, title]);

  return (
    <>
      <span
        id={id}
        className={className}
        style={style}
        onClick={onClick}
      >
        {children}
      </span>
      {title && (
      <UncontrolledTooltip
        target={id}
      >
        {title}
      </UncontrolledTooltip>
      )}

    </>
  );
}

export default Span;
